import React, { lazy, useEffect, useRef } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom'
import cookie from 'react-cookies'
// import Home from './pages/Home';
// import About from './pages/About';
import { GlobalStyle } from './style';

import './statics/css/icons.css'
import './statics/css/dark-theme.css'
import './statics/css/semi-dark.css'
import 'react-perfect-scrollbar/dist/css/styles.css';
// import 'bootstrap/dist/css/bootstrap.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import './statics/css/app.css'
import { Provider } from 'react-redux'
import Content from './common/content';
import store from './store';

import './i18n/config'
//import Login from './pages/Login';
//import Active from './pages/active';
//import TimeOut from './pages/timeout';
//import Invalid404 from './pages/invalid404';
//import AutoLogin from './pages/autoLogin';
const Login = lazy(() => import(/* webpackChunkName: 'login' */'./pages/Login'))
const Active = lazy(() => import(/* webpackChunkName: 'active' */'./pages/Active'))
const TimeOut = lazy(() => import(/* webpackChunkName: 'timeout' */'./pages/TimeOut'))
const AutoLogin = lazy(() => import(/* webpackChunkName: 'autoLogin' */'./pages/autoLogin'))
const Invalid404 = lazy(() => import(/* webpackChunkName: 'invalid404' */'./pages/invalid404'))
const Home2 = lazy(() => import(/* webpackChunkName: 'login' */'./pages/Home2'))

/** 不需要登录的公共路由，进入这些路由后不启动空闲计时器 */
const PUBLIC_PATHS = ['/', '/login', '/autoLogin', '/404', '/timeout', '/active'];

/** 无操作自动登出时长（测试阶段：3小时） */
const IDLE_TIMEOUT_MS =   3 * 60 * 60 * 1000;

/** 空闲计时可观测开关：true 时输出重置来源、到期时间和触发漂移 */
const IDLE_OBSERVE = true;

/** 触发"用户活跃"的 DOM 事件列表（接口轮询不在此列，不会重置计时） */
const IDLE_EVENTS = ['mousemove', 'mousedown', 'click', 'keydown', 'scroll', 'touchstart'];
  
/**
 * 全局空闲检测组件：在已登录路由下监听用户活动。
 * 超过 IDLE_TIMEOUT_MS 无操作后，清除本地 token 并跳转至 /timeout 页面。
 */
function IdleWatcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const timerRef = useRef(null);
  const deadlineRef = useRef(0);
  const lastResetRef = useRef({ source: 'init', at: 0 });

  useEffect(() => {
    const logIdle = (label, payload = {}) => {
      if (!IDLE_OBSERVE) return;
      console.log('[IdleWatcher]', label, {
        ...payload,
        path: location.pathname,
        now: new Date().toISOString(),
      });
    };

    // 公共页面（登录页、超时页等）不启动计时
    if (PUBLIC_PATHS.includes(location.pathname)) {
      logIdle('skip-public-path');
      return;
    }

    const resetTimer = (source = 'unknown') => {
      clearTimeout(timerRef.current);

      const startAt = Date.now();
      const deadlineAt = startAt + IDLE_TIMEOUT_MS;
      deadlineRef.current = deadlineAt;
      lastResetRef.current = { source, at: startAt };

      logIdle('timer-reset', {
        source,
        timeoutMs: IDLE_TIMEOUT_MS,
        deadlineAt: new Date(deadlineAt).toISOString(),
      });

      timerRef.current = setTimeout(() => {
        const firedAt = Date.now();
        const driftMs = firedAt - deadlineRef.current;
        const lastResetAt = lastResetRef.current.at
          ? new Date(lastResetRef.current.at).toISOString()
          : null;

        logIdle('timer-fired', {
          firedAt: new Date(firedAt).toISOString(),
          expectedAt: new Date(deadlineRef.current).toISOString(),
          driftMs,
          lastResetSource: lastResetRef.current.source,
          lastResetAt,
          elapsedSinceLastResetMs: lastResetRef.current.at ? firedAt - lastResetRef.current.at : null,
        });

        // 与现有 userLogout 逻辑保持一致，清除 cookie 和 sessionStorage 中的 token
        cookie.remove('userToken', { path: '/' });
        cookie.remove('userId', { path: '/' });
        window.sessionStorage.removeItem('userToken');
        window.sessionStorage.removeItem('userId');
        navigate('/timeout');
      }, IDLE_TIMEOUT_MS);
    };

    const eventHandlers = {};
    // passive: true 避免阻塞滚动事件，减少性能影响
    IDLE_EVENTS.forEach(e => {
      eventHandlers[e] = () => resetTimer(e);
      window.addEventListener(e, eventHandlers[e], { passive: true });
    });

    const handleVisibilityChange = () => {
      logIdle('visibility-change', { visibilityState: document.visibilityState });
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    resetTimer('route-enter'); // 进入已登录页面时立即启动计时

    return () => {
      logIdle('cleanup');
      clearTimeout(timerRef.current);
      IDLE_EVENTS.forEach(e => window.removeEventListener(e, eventHandlers[e]));
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [location.pathname, navigate]);

  return null;
}

function App() {
  return (
    <>
      <Provider store={store}>
        <IdleWatcher />
        <Routes>
          <Route path='/autoLogin' element={<AutoLogin />} />
          <Route path='/404' element={<Invalid404 />} />
          <Route path='/timeout' element={<TimeOut />} />
          <Route path='/active' element={<Active />} />
          <Route path='/' element={<Login />} />
          <Route path='/login' element={<Login />} />
          <Route path='/home2' element={<Home2 />} />
          <Route path='/*' element={<Content />} />
        </Routes>
      </Provider>
      <GlobalStyle />
    </>
  )
}

export default App;